const dependentEntities = new Map<string, Set<string>>();

export function addDependentEntities(entity: string, addedDependentEntities: string[]) {
  addedDependentEntities.forEach((dependentEntity) => {
    if (!dependentEntities.has(dependentEntity)) {
      dependentEntities.set(dependentEntity, new Set<string>());
    }

    dependentEntities.get(dependentEntity)!.add(entity);
  });
}

export function getDependentEntities(entity: string) {
  return Array.from(dependentEntities.get(entity) ?? []);
}

export function resetDependentEntities() {
  dependentEntities.clear();
}
